
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M20.4898 3.50998C19.9298 2.94998 18.3398 2.53998 16.3298 2.53998C13.2498 2.53998 9.17976 3.49998 6.34976 6.32998C1.65976 11.03 2.09976 19.07 3.50976 20.49C4.06976 21.05 5.65976 21.46 7.66976 21.46C10.7498 21.46 14.8198 20.5 17.6498 17.67C22.3398 12.97 21.8998 4.92998 20.4898 3.50998ZM7.75976 7.75998C10.3998 5.11998 14.1098 4.63998 15.7898 4.56998C13.7398 5.50998 11.3298 7.01998 9.17976 9.17998C7.01976 11.34 5.50976 13.76 4.56976 15.81C4.65976 13.33 5.43976 10.07 7.75976 7.75998ZM16.2398 16.24C13.5998 18.88 9.88976 19.36 8.20976 19.43C10.2598 18.49 12.6698 16.98 14.8198 14.82C16.9798 12.66 18.4898 10.24 19.4398 8.18998C19.3398 10.67 18.5598 13.93 16.2398 16.24Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-sports-rugby`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSportsRugby

    ```js
    <b-new-b-icon-sports-rugby />
    ```
</docs>


